import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { Icon } from '../Icon';
var InvisibleSvg = function InvisibleSvg() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20.908 22.249 2 3.169l.912-.92L7.23 6.608C8.578 5.45 10.118 4.66 12.12 4.66c2.223 0 3.877.974 5.328 2.344.72.679 1.399 1.463 2.076 2.28q.325.393.65.792l.001.001c.469.574.945 1.156 1.455 1.744l.371.428-.371.428c-.51.588-.985 1.169-1.452 1.74q-.367.45-.732.891a27 27 0 0 1-1.706 1.903l4.08 4.118zM10.218 9.622 8.146 7.531c1.164-.981 2.402-1.57 3.973-1.57 1.787 0 3.142.76 4.448 1.993.659.622 1.296 1.355 1.967 2.165q.309.373.631.768c.362.443.738.902 1.127 1.362-.39.46-.764.918-1.127 1.362q-.361.444-.708.861a26 26 0 0 1-1.63 1.82l-2.105-2.125a3.25 3.25 0 0 0 .621-1.866 3.28 3.28 0 0 0-.961-2.371 3.22 3.22 0 0 0-2.365-.933 3.2 3.2 0 0 0-1.799.625m.93.939 2.644 2.668a1.95 1.95 0 0 0 .262-.95 1.97 1.97 0 0 0-.577-1.422 1.93 1.93 0 0 0-1.418-.56 1.9 1.9 0 0 0-.91.264",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4.072 10.07c.407-.498.809-.99 1.21-1.457l.974.852c-.39.455-.783.935-1.192 1.435l-.094.116c-.33.402-.669.816-1.022 1.233.389.46.764.918 1.126 1.361l.632.77c.67.808 1.308 1.542 1.967 2.164 1.306 1.232 2.66 1.993 4.447 1.993 1.008 0 1.866-.24 2.65-.659l.602 1.15c-.96.513-2.025.81-3.252.81-2.222 0-3.876-.974-5.327-2.344-.72-.679-1.399-1.463-2.076-2.28q-.326-.394-.652-.794a78 78 0 0 0-1.454-1.743l-.371-.428.37-.428a74 74 0 0 0 1.365-1.634z"
  }));
};
export var Invisible = function Invisible(props) {
  return /*#__PURE__*/React.createElement(Icon, _extends({}, props, {
    component: InvisibleSvg
  }));
};